import ReactOnRails from 'react-on-rails/client';
import ResultsDataResults from '../../app/ResultsDataResults.js';

ReactOnRails.register({ResultsDataResults});